// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app{position:relative;z-index:0}body{overflow-x:hidden}ion-menu ion-content ion-toolbar,ion-popover ion-toolbar{--background:transparent!important}", ""]);
// Exports
module.exports = exports;
